"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var deg2rad_1 = __importDefault(require("./deg2rad"));

function getDistanceFromLatLonInMi(lat1, lon1, lat2, lon2) {
  var R = 3959; // Radius of the earth in mi

  var dLat = (0, deg2rad_1.default)(lat2 - lat1); // deg2rad below

  var dLon = (0, deg2rad_1.default)(lon2 - lon1);
  var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos((0, deg2rad_1.default)(lat1)) * Math.cos((0, deg2rad_1.default)(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c; // Distance in km

  return d;
}

exports.default = getDistanceFromLatLonInMi;